/* eslint-disable react/jsx-one-expression-per-line */
/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { renderDefaultError, renderDefaultLoading } from '@exo/frontend-common-utils';
import { useFetchStatementsDetails } from '../../hooks/useFetchStatements';

export const TDStatementsContainer = ({
  statementsReq,
  render,
  renderLoading = renderDefaultLoading,
  renderError = renderDefaultError
}: any) => {
  const { data, loading, error } = useFetchStatementsDetails(statementsReq);
  if (loading) return renderLoading();
  if (error) return renderError(error);

  return render({ statementsData: data });
};
